<template>
	<div>
		<modal ref="modal">
			<div style="min-height: 400px">
				<h4 class="modal-title">
					LOGS de {{ nome }}
					<button type="button" class="close" @click="$refs.modal.modalHide()">
						<span aria-hidden="true">&times;</span>
					</button>
				</h4>
				<hr style="margin-bottom: 0px; margin-top: 5px" />

				<div class="row" style="margin-top: 20px">
					<div class="col-sm-12 col-md-2 form-group">
						<label>{{ _traducao('menuRGhorasVoadas', 'menuRGdataInicio') }}:</label>
						<flDateTime
							@v-model="(val) => (inicio = val)"
							:value="inicio"
							name="dtOrdemInicio"
							:lang="_getLangDp"
							:format="_formatDate"
						/>
					</div>

					<div class="col-sm-12 col-md-2 form-group">
						<label>{{ _traducao('menuRGhorasVoadas', 'menuRGdataFim') }}:</label>
						<flDateTime
							@v-model="(val) => (fim = val)"
							:value="fim"
							name="dtOrdemFim"
							:minDate="inicio"
							:lang="_getLangDp"
							:format="_formatDate"
						/>
					</div>

					<div class="col-md-3 col-xs-12 form-group">
						<label style="color: #fff">carregar</label>
						<button type="button" @click="carrega" :disabled="inicio == '' || fim == ''" class="btn btn-info btn-sm btn-block">
							<i class="fa fa-refresh"></i> CARREGAR
						</button>
					</div>
				</div>

				<div v-if="lista.length > 0">
					<div class="row">
						<div class="col-xs-12">
							<button class="btn btn-info pull-right btn-xs" @click="downloadCSV">
								<i class="fa fa-file-excel-o" aria-hidden="true"></i> Download Excel
							</button>
							<table ref="tabela" class="table table-lista table-striped table-hover">
								<thead>
									<tr>
										<th>{{ _traducao('global', 'nome') }}</th>
										<th>Data</th>
										<th>Tipo</th>
										<th>IP</th>
										<th>URL</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(item, index) in lista" :key="index">
										<td>{{ item.nome }}</td>
										<td>{{ item._data }}</td>
										<td>{{ item.tipo }}</td>
										<td>{{ item.ip }}</td>
										<td>{{ item.url }}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import flDateTime from '../datetime/main.vue'
export default {
	components: {
		flDateTime
	},

	data() {
		return {
			id: '',
			nome: '',
			inicio: '',
			fim: '',
			lista: []
		}
	},

	methods: {
		carregaLog(id, nome) {
			this.id = id
			this.nome = nome
			this.lita = []
			this.$refs.modal.modalShow(90)
		},

		convertArrayOfObjectsToCSV(args) {
			var result, ctr, keys, columnDelimiter, lineDelimiter, data

			data = args.data || null
			if (data == null || !data.length) {
				return null
			}

			columnDelimiter = args.columnDelimiter || ','
			lineDelimiter = args.lineDelimiter || '\n'

			keys = Object.keys(data[0])

			result = ''
			result += keys.join(columnDelimiter)
			result += lineDelimiter

			data.forEach(function (item) {
				ctr = 0
				keys.forEach(function (key) {
					if (ctr > 0) result += columnDelimiter

					result += item[key]
					ctr++
				})
				result += lineDelimiter
			})

			return result
		},

		downloadCSV(args) {
			var a = document.createElement('a')
			var data_type = 'data:application/vnd.ms-excel'
			var table_div = this.$refs.tabela
			var table_html = table_div.outerHTML.replace(/ /g, '%20')
			a.href = data_type + ', ' + table_html
			a.download = 'log-' + this.nome + '-' + this.inicio + '.xls'
			a.click()
		},

		carrega() {
			//$id_usuario/$inicio/$fim

			var inicio = this._dateToDateSQL(this.inicio, $sessao.getDateFormat())
			var fim = this._dateToDateSQL(this.fim, $sessao.getDateFormat())

			bus.$emit('load-in', {text: 'Carregando'})
			this.lista = []
			this._httpGet('Acesso/get/' + this.id + '/' + inicio + '/' + fim, (response) => {
				bus.$emit('load-out')

				if (response._request && response._status) {
					this.lista = response.lista.map((item) => {
						item._data = this._SQLDateToDateTime(item.data, $sessao.getDateFormat() + ' HH:MM')
						return item
					})
				}
			})
		}
	}
}
</script>